import { createSlice } from '@reduxjs/toolkit'

import {
  fetchAdministratorEmails,
  fetchTool,
  generatePermaLink,
  saveTool,
  updateTool,
  updateToolState,
} from 'redux/thunks/ToolBuilder'

interface ToolBuilder {
  toolBuilder: Record<string, any>
  saving: boolean
  fetching: boolean
  error: any
  validation: Record<string, string>
  lookups: Record<string, any>
  invalidGroups?: string[]
}

const initialState: ToolBuilder = {
  toolBuilder: {},
  saving: false,
  fetching: false,
  error: null,
  validation: {},
  lookups: {},
}

export const toolBuilder = createSlice({
  name: 'toolBuilder',
  initialState,
  reducers: {
    setToolBuilder: (state, action) => {
      const { name, value } = action.payload
      state.toolBuilder = { ...state.toolBuilder, [name]: value }
    },
    setValidation: (state, action) => {
      const { name, value } = action.payload
      state.validation = { ...state.validation, [name]: value }
    },
    setValidationError: (state, action) => {
      const { error } = action.payload
      state.error = error
    },
    setInvalidGroups: (state, action) => {
      const { name } = action.payload

      if (state.invalidGroups) {
        if (!state.invalidGroups.includes(name))
          state.invalidGroups = [...state.invalidGroups, name]
      } else {
        state.invalidGroups = [name]
      }
    },
    resetValidation: (state) => {
      state.validation = {}
      state.invalidGroups = []
    },
  },
  extraReducers: {
    [fetchTool?.pending?.toString()]: (state) => {
      state.fetching = true
    },
    [fetchTool?.fulfilled?.toString()]: (state, action) => {
      state.toolBuilder = action.payload
      state.fetching = false
    },
    [fetchTool?.rejected?.toString()]: (state, action) => {
      state.error = action.payload
      state.fetching = false
    },
    [saveTool?.pending?.toString()]: (state) => {
      state.saving = true
    },
    [saveTool?.fulfilled?.toString()]: (state, action) => {
      state.toolBuilder = action.payload
      state.saving = false
    },
    [saveTool?.rejected?.toString()]: (state, action) => {
      state.error = action.payload
      state.saving = false
    },
    [updateTool?.pending?.toString()]: (state) => {
      state.saving = true
    },
    [updateTool?.fulfilled?.toString()]: (state, action) => {
      state.toolBuilder = action.payload
      state.saving = false
    },
    [updateTool?.rejected?.toString()]: (state, action) => {
      state.error = action.payload
      state.saving = false
    },
    [updateToolState?.pending?.toString()]: (state) => {
      state.saving = true
    },
    [updateToolState?.fulfilled?.toString()]: (state) => {
      state.saving = false
    },
    [updateToolState?.rejected?.toString()]: (state, action) => {
      state.error = action.payload
      state.saving = false
    },
    [generatePermaLink?.pending?.toString()]: (state) => {
      state.fetching = true
    },
    [generatePermaLink?.fulfilled?.toString()]: (state, action) => {
      state.lookups = {
        ...state.lookups,
        permaLink: [action?.payload],
      }
      state.fetching = false
    },
    [generatePermaLink?.rejected?.toString()]: (state, action) => {
      state.error = action.payload
      state.fetching = false
    },
    [fetchAdministratorEmails?.fulfilled?.toString()]: (state, action) => {
      state.lookups = {
        ...state.lookups,
        adminEmails: action?.payload,
      }
    },
    [fetchAdministratorEmails?.rejected?.toString()]: (state, action) => {
      state.error = action.payload
    },
  },
})

export const {
  setToolBuilder,
  setInvalidGroups,
  setValidation,
  resetValidation,
  setValidationError,
} = toolBuilder.actions

export default toolBuilder.reducer
